import React from 'react';
import { Grid } from 'semantic-ui-react';
import { ImagesPropType } from '../../../services/proptypes';
import ImageRow from './ImageRow';
var defaultProps = {
  rightArrow: null,
  leftArrow: null
};
export default function ImageGrid(_ref) {
  var imageGroups = _ref.imageGroups,
      rightArrow = _ref.rightArrow,
      leftArrow = _ref.leftArrow;
  return /*#__PURE__*/React.createElement(Grid, {
    className: "ic-image-grid",
    stackable: true
  }, leftArrow, imageGroups.map(function (imageGroup) {
    return /*#__PURE__*/React.createElement(ImageRow, {
      key: JSON.stringify(imageGroup),
      imageGroup: imageGroup
    });
  }), rightArrow);
}
ImageGrid.defaultProps = defaultProps;